const middleware = {}

middleware['default'] = require('../src/middleware/default.js')
middleware['default'] = middleware['default'].default || middleware['default']

export default middleware
